import React from 'react';

import { CommonModal } from '~src/commons/components/common-modal';
import { useLogPosthogEvent } from '~src/commons/services/posthog-service';
import { useTranslations } from '~src/commons/utils/translations/translate';

interface NoOptionsModalProps {
  onClose: () => void;
  onSubmit: () => void;
}

export const NoOptionsModal: React.FC<NoOptionsModalProps> = ({ onClose, onSubmit }) => {
  const { tICU } = useTranslations();
  const logPosthogEvent = useLogPosthogEvent();

  React.useEffect(() => {
    logPosthogEvent('No Shipping Options Error Viewed');
  }, []);

  return (
    <CommonModal
      title={tICU('widget.error_modal.NO_OPTIONS_FOUND_FOR_ADDRESS.TITLE')}
      ariaTitle={tICU('widget.aria.NO_OPTIONS_FOUND_FOR_ADDRESS_MODAL.ERROR.TITLE')}
      body={tICU('widget.error_modal.NO_OPTIONS_FOUND_FOR_ADDRESS.DESCRIPTION')}
      primaryButtonText={tICU('widget.EMPTY_LOCATIONS_ADDRESS_BUTTON')}
      secondaryButtonText={tICU('widget.CANCEL_BUTTON')}
      onPrimaryButtonClick={onSubmit}
      onSecondaryButtonClick={onClose}
      onClose={onClose}
    />
  );
};
